export default function ($http, currentUser) {
    return function (pageNumber = 0, requestParams = {}) {
        const url = `api/tasks/${ pageNumber }`;

        return $http.get(url, {params: requestParams})
                .then(x => x.data.result)
                .then(x => {
                    return currentUser()
                         .then(result => {
                             x.tasks = x.tasks.map(task => {
                                 task.isOwned = task.ownedBy !== null;
                                 task.isOwnedByCurrentUser = task.ownedBy === result.name;
                                 task.isOwnedByOtherUser = task.isOwned && !task.isOwnedByCurrentUser;

                                 return task;
                             });
                             return x;
                         });
                });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/tasks/getTasks.js